import { Capacitor } from '@capacitor/core'

export const APP_PACKAGE_ID = 'com.mastermind.coaching'
export const APP_SCHEME = 'mastermind'
export const PRODUCTION_WEB_HOST = 'victorious-glacier-0e6507000.6.azurestaticapps.net'

export const invitationWebUrl = (token: string, baseUrl?: string) => {
  const origin = (baseUrl || (typeof window !== 'undefined' ? window.location.origin : `https://${PRODUCTION_WEB_HOST}`)).replace(/\/$/, '')
  return `${origin}/accept-invitation?token=${encodeURIComponent(token)}`
}

export const invitationNativeUrl = (token: string) =>
  `${APP_SCHEME}://accept-invitation?token=${encodeURIComponent(token)}`

export const invitationFallbackWebUrl = (webUrl: string) => {
  try {
    const url = new URL(webUrl)
    url.searchParams.set('skipApp', '1')
    return url.toString()
  } catch {
    return webUrl.includes('?') ? `${webUrl}&skipApp=1` : `${webUrl}?skipApp=1`
  }
}

export const invitationIntentUrl = (token: string, webUrl: string) =>
  `intent://accept-invitation?token=${encodeURIComponent(token)}#Intent;scheme=${APP_SCHEME};package=${APP_PACKAGE_ID};S.browser_fallback_url=${encodeURIComponent(invitationFallbackWebUrl(webUrl))};end`

export const parseInvitationPath = (rawUrl: string): string | null => {
  try {
    const normalized = rawUrl.replace(`${APP_SCHEME}://`, 'https://app.local/')
    const url = new URL(normalized)
    if (!url.pathname.includes('accept-invitation')) {
      return null
    }
    const token = url.searchParams.get('token') || ''
    return token ? `/accept-invitation?token=${encodeURIComponent(token)}` : '/accept-invitation'
  } catch {
    return null
  }
}

export const shouldOfferNativeHandoff = (search = typeof window !== 'undefined' ? window.location.search : '') => {
  if (Capacitor.isNativePlatform()) {
    return false
  }
  if (typeof navigator === 'undefined' || !/Android/i.test(navigator.userAgent)) {
    return false
  }
  return new URLSearchParams(search).get('skipApp') !== '1'
}

export const handoffInvitationToAppIfInstalled = (token: string, webUrl: string) => {
  if (!token || !shouldOfferNativeHandoff()) {
    return
  }
  window.location.href = invitationIntentUrl(token, webUrl)
}
